import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const estates = [
  {
    id: "royal-dynasty",
    name: "Royal Dynasty Estate",
    location: "Apo-Wumba, FCT Abuja",
    price: "2‑3 Bedroom • ₦40M – ₦50M",
    image: "/assets/img/estates/Royal Dynasty Estate.png",
  },
 {
  id: "emperor-villa",
  name: "Emperor Villa Estate",
  location: "Kodo, FCT Abuja (behind Life Camp)",
  price: "3‑5 Bedroom • ₦45M – ₦140M",
  image: "/assets/img/estates/Emperor Villa Estate_2.png",
},
];

const EstateShowcase = () => {
  return (
    <section className="pt-5 pb-5" style={{ background: "#f9f9f9" }}>
      <style>{`
        .estate-showcase {
          max-width: 1100px;
          margin: 0 auto;
        }
        .section-heading {
          text-align: center;
          margin-bottom: 2.5rem;
        }
        .section-heading h2 {
          font-size: 2.4rem;
          font-weight: 700;
          color: #0a1a3d;
        }
        .section-heading p {
          color: #666;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
        }
        .estate-slide {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          flex-wrap: wrap;
        }
        .estate-slide .text-col {
          flex: 1 1 350px;
          padding: 40px;
        }
        .estate-slide .text-col h3 {
          font-size: 2rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .estate-slide .text-col h3 span {
          color: #e86b24;
          position: relative;
        }
        .estate-slide .text-col h3 span::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 50px;
          height: 3px;
          background: #e86b24;
          border-radius: 2px;
        }
        .estate-slide .text-col .location {
          font-size: 1rem;
          color: #666;
          margin-bottom: 0.5rem;
        }
        .estate-slide .text-col .price {
          font-size: 1.2rem;
          font-weight: 600;
          color: #fff;           /* now white */
          margin-bottom: 1.5rem;
        }
        .estate-slide .text-col .btn-readmore {
          background: #e86b24;
          color: #fff;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          text-decoration: none;
          display: inline-block;
          transition: background 0.3s, transform 0.2s;
        }
        .estate-slide .text-col .btn-readmore:hover {
          background: #d2551a;
          transform: translateY(-2px);
        }
        .estate-slide .img-col {
          flex: 1 1 400px;
          min-height: 350px;
          background-size: cover;
          background-position: center;
          border-radius: 0 20px 20px 0;
        }
        /* Dot pagination styling */
        .swiper-pagination-bullet {
          background: #0a1a3d;
          opacity: 0.3;
        }
        .swiper-pagination-bullet-active {
          background: #e86b24;
          opacity: 1;
        }
        @media (max-width: 768px) {
          .estate-slide {
            flex-direction: column-reverse;
          }
          .estate-slide .img-col {
            width: 100%;
            height: 300px;
            border-radius: 0;
          }
          .estate-slide .text-col {
            padding: 25px;
          }
        }
      `}</style>

      <div className="container estate-showcase">
        <div className="section-heading">
          <h2>Discover Our Estates</h2>
          <p>Experience luxury living in Abuja's most exclusive communities</p>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={30}
          pagination={{ clickable: true }}
          autoplay={{ delay: 8000, disableOnInteraction: false }}
          loop
        >
          {estates.map((estate) => (
            <SwiperSlide key={estate.id}>
              <div className="estate-slide">
                <div className="text-col">
                  <h3>
                    <span>{estate.name}</span>
                  </h3>
                  <p className="location">{estate.location}</p>
                  <p className="price">{estate.price}</p>
                  <Link to={`/estates/${estate.id}`} className="btn-readmore">
                    Read More
                  </Link>
                </div>
                <div
                  className="img-col"
                  style={{ backgroundImage: `url('${estate.image}')` }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/top-estates" className="btn-view-all"
            style={{
              background: '#fff',
              color: '#e86b24',
              border: '2px solid #e86b24',
              padding: '12px 30px',
              borderRadius: '50px',
              fontWeight: 600,
              textDecoration: 'none',
              display: 'inline-block',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#e86b24';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.color = '#e86b24';
            }}
          >
            View All Top Estates <i className="fas fa-arrow-right ms-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default EstateShowcase;